
import localStorage from './src/utils/localStorage.js'
import loadScript from './src/utils/loadScript.js'
import api from './src/api.js'

import en from './src/language/en.js'
import hk from './src/language/hk.js'


export default {
    en,
    hk,
    localStorage,
    loadScript,
    api
}